'use client';

import { useTranslation } from '@whoop/i18n/lang/client';
import clsx from 'clsx';
import { Button } from '../../ButtonV2/Button';
export interface NewReferAFriendProps extends React.HTMLAttributes<HTMLDivElement> {
  onShareClick: () => void;
  imageSrc: string;
  linkCopied?: boolean;
}
export function NewReferAFriend({
  onShareClick,
  className,
  imageSrc,
  linkCopied = false,
  ...props
}: NewReferAFriendProps) {
  const {
    t
  } = useTranslation('receiptPage');
  return <div className={clsx('flex w-[calc(100%-20px)] flex-row items-center justify-center p-5', 'md:flex-row', className)} {...props} data-sentry-component="NewReferAFriend" data-sentry-source-file="NewReferAFriend.tsx">
      <img alt={t('rafAltText')} className='-mr-[4%] mb-4 h-auto w-full w-full rounded-none object-contain md:mb-0 md:mr-0 md:rounded-2xl' src={imageSrc} />
      <div className='m-0 flex max-w-full flex-col text-center md:mx-[10px] md:ml-[15px] md:max-w-[380px] md:text-start'>
        <h3 className='mb-[5px] w-full text-[25px] font-semibold leading-[35px] tracking-[-0.04em] md:w-[210px] md:text-[30px]'>
          {t('rafTitle')}
        </h3>
        <p className='m-0 text-base font-normal leading-5 tracking-[-0.03em]'>
          {t('rafSubtitle')}
        </p>
      </div>
      <Button className='mt-4 h-[57px] w-full min-w-[125px] p-4 text-sm font-normal md:mt-0 md:w-auto' onClick={onShareClick} size='large' variant={linkCopied ? 'primary' : 'tertiary'} data-sentry-element="Button" data-sentry-source-file="NewReferAFriend.tsx">
        {linkCopied ? t('rafLinkCopied') : t('rafShareButtonText')}
      </Button>
    </div>;
}